// import { ClientList } from "components/Client";
import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../../layouts";
import { ClientList } from "../../../components/Client/ClientList";

export interface IClientListPage {}

export const ClientListPage: FC<IClientListPage> = (props: IClientListPage) => {
	return (
		<AuthenticatedLayout
			pageTitle="Client List"
			pageTitleIcon={<DescriptionOutlinedIcon />}
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[
				// { text: "Client", navigateTo: "/clients/list" },
			]}
			mainContents={<ClientList />}
		/>
	);
};
